import { ENDPOINT } from "@/config";
import axios from "axios";
import { normaliseCountries, normaliseStates } from "@/utils";
import * as queryString from "query-string";

// Default state
const defaultState = () => {
  return {
    // Toggles
    error: null,
    countriesIsLoading: false,
    deliveryMethodIsLoading: false,
    countryStatesIsLoading: false,

    // Data
    countries: [],
    states: [],
    deliveryMethods: [],
  };
};

// State object
const state = defaultState();

// Getter functions
const getters = {
  getCountries: (state) => {
    return state.countries;
  },
  getCountryStates: (state) => {
    return state.states;
  },
  getCountryError(state) {
    return state.error;
  },
};

// Actions
const actions = {
  async getCountriesAction({ commit }) {
    commit("SET_COUNTRIES_IS_LOADING", true);

    return new Promise((resolve, reject) => {
      axios
        .get(ENDPOINT.countries)
        .then((response) => {
          commit("SET_COUNTRIES_IS_LOADING", false);
          commit("SET_COUNTRIES", normaliseCountries(response.data));
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response) {
            commit("SET_ERROR", error.response.data);
          }

          commit("SET_COUNTRIES_IS_LOADING", false);
          reject(error.response.data);
        });
    });
  },
  async getCountryDeliveryMethods({ commit }, data) {
    commit("SET_DELIVERY_METHODS_IS_LOADING", true);

    return new Promise((resolve, reject) => {
      axios
        .post(ENDPOINT.countryDeliveryMethods, data)
        .then((response) => {
          commit("SET_DELIVERY_METHODS_IS_LOADING", false);
          commit("SET_DELIVERY_METHODS", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response) {
            commit("SET_ERROR", error.response.data);
            reject(error.response.data);
          }

          commit("SET_DELIVERY_METHODS_IS_LOADING", false);
        });
    });
  },
  async getCountryStatesById({ commit }, id) {
    commit("SET_COUNTRY_STATES_IS_LOADING", true);

    const query = queryString.stringify({ country_id: id });

    return new Promise((resolve, reject) => {
      axios
        .get(`${ENDPOINT.countryStates}?${query}`)
        .then((response) => {
          commit("SET_COUNTRY_STATES_IS_LOADING", false);
          commit("SET_COUNTRY_STATES", normaliseStates(response.data));
          resolve(response.data);
        })
        .catch((error) => {
          if (error.response) {
            commit("SET_ERROR", error.response.data);
          }

          commit("SET_COUNTRY_STATES_IS_LOADING", false);
          reject(error.response.data);
        });
    });
  },
  resetState({ commit }) {
    commit("RESET_STATE");
  },
};

// Mutations
const mutations = {
  SET_COUNTRY_STATES_IS_LOADING(state, isLoading) {
    state.countryStatesIsLoading = isLoading;
  },
  SET_DELIVERY_METHODS_IS_LOADING(state, isLoading) {
    state.deliveryMethodIsLoading = isLoading;
  },
  SET_COUNTRIES_IS_LOADING(state, isLoading) {
    state.countriesIsLoading = isLoading;
  },
  SET_COUNTRY_STATES(state, states) {
    state.states = states;
  },
  SET_DELIVERY_METHODS(state, deliveryMethods) {
    state.deliveryMethods = deliveryMethods;
  },
  SET_COUNTRIES(state, countries) {
    state.countries = countries;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  RESET_STATE(state) {
    Object.assign(state, defaultState());
  },
};

export default {
  name: "CountryModule",
  dynamic: true,
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
